export default __webpack_public_path__ + "8a213319edd930a0cf008cdd8fb44112.png";